import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';
import type { AddListingToTourResponse } from '@/app-package';

/**
 * Adds a listing to an existing virtual tour
 * @param virtualTourId - The ID of the virtual tour to add the listing to
 * @param listingId - The ID of the listing to add
 * @param invitees - Optional list of invitees for this listing
 */
const addListingToTour = async ({
  virtualTourId,
  listingId,
  invitees,
}: {
  virtualTourId: string;
  listingId: string;
  invitees?: any[];
}) => {
  const config: AxiosRequestConfig = {
    url: `/virtual_tour/${virtualTourId}/property_to_tour/add`,
    method: 'post',
    data: { listingId, invitees },
  };

  const { data } = await axios.request<AddListingToTourResponse>(config);

  return data;
};

export default addListingToTour;
